/**
 * SitePick front — 購入 lock 中（RESERVED）の補助メッセージ。
 *
 * お気に入り（`favorites.js`）と比較（`compare.js`）が共通で使う。PHP 側の
 * `sitepick_purchase_lock_notice( $state, 'card' )` と**同じ文**を出すためだけのモジュール。
 *
 * ## 残り時間の計算はここでしない
 *
 * 残り分は **core の `ProductState`（`reserved_minutes_left`）が唯一の実装**で、
 * REST（`/sitepick/v1/sites/batch`）が返した整数をそのまま文に埋めるだけ。
 * `reserved_until` は REST に出さず、JS で期限を計算したり状態を独自判断したりしない。
 * 値が無い（null）ときは時間を言わない —— 推測で数字を出さない。
 *
 * ## 取置き（HELD / RESERVED + hold_active）
 *
 * 取置きが絡む状態（`hold_active`）では「約 N 分後」を**出さない**（holder の lock が解けても
 * HELD に戻るため事実と違う）。文は `hold-notice.js`（PHP の `sitepick_hold_notice()` と同文）に任せる。
 */

import { holdNoticeText } from "./hold-notice.js";

function messages() {
  return (window.SITEPICK && window.SITEPICK.messages) || {};
}

function msg(key, fallback) {
  const m = messages();
  return typeof m[key] === "string" && m[key] ? m[key] : fallback;
}

/**
 * @param {Object} site REST `/sites/batch` の 1 件（`reserved_minutes_left`: int|null、`hold_active`、`hold_hours_left`）。
 * @returns {string}
 */
export function lockNoticeFor(site) {
  if (site && (site.status === "HELD" || site.hold_active === true)) {
    // HELD / holder の購入手続き中は時間単位の取置き文言（カードの短い形）。
    return holdNoticeText({ status: "HELD", hold_active: true, hold_hours_left: site.hold_hours_left }, messages(), "card");
  }
  const minutes = site.reserved_minutes_left;
  if (!Number.isInteger(minutes)) {
    return msg("lockNoticeCardUnknown", "ほかのお客様が購入手続き中です");
  }
  if (minutes <= 0) {
    return msg("lockNoticeCardSoon", "まもなく購入できる可能性があります");
  }
  return msg("lockNoticeCard", "約%d分後に購入できる可能性があります").replace("%d", String(minutes));
}
